import getApplicationType from "./utils/get-application-type.utils";

export const MAGNOLIA_BASE_URL = process.env.NEXT_PUBLIC_MGNL_HOST || "";
export const MAGNOLIA_REST_URL = `${MAGNOLIA_BASE_URL}/.rest`;
export const MAGNOLIA_NEXT_API_URL = `/api/magnolia`;
export const MAGNOLIA_ANNOTATION_URL = `/template-annotations/v1`;
export const MAGNOLIA_PHONE_NUMBER_URL = `/delivery/brochure/phone-numbers/v1`;
export const MAGNOLIA_PAGES_URL = `${MAGNOLIA_BASE_URL}/.rest/pages/v1`;
export const DYNAMIC_FOOTER_URL = `/delivery/dynamicFooters`;
export const NOT_FOUND_URL = `/delivery/notFounds`;
export const GENERIC_ERROR_URL = `/delivery/genericErrors`;
export const QUOTE_ERROR_URL = `/delivery/quoteErrors`;
export const APP_CONFIG_URL = `${MAGNOLIA_REST_URL}/delivery/appConfig`;
export const TRUSTPILOT_CONTENT_URL = `/delivery/trustPilotContent`;
export const COUNTRY_CHANGE_FOOTER_URL = `/delivery/countryChangeFooter`;
export const EXPANDED_FOOTER_URL = `/delivery/expandedFooters`;
export const SESSION_EXPIRE_URL = `/delivery/sessionExpiredErrors`;
export const CONTENT_PATH: string =
  process.env.NEXT_PUBLIC_MGNL_SITE_PATH ?? "";
export const language: string = "en";
export const HELP_OVERLAY_URL = `/delivery/helpoverlays`;
export const QUOTE_DASHBOARD_URL = `/delivery/quoteDashBoards/quoteDashBoards`;
export const MAIN_PAGE_URL =
  process.env.NEXT_PUBLIC_BROCHURE_URI || `https://www.staysure.co.uk/`;
export const AVT_MAIN_PAGE_URL = `https://www.avantitravelinsurance.co.uk/`;
export const EXPAT_MAIN_PAGE_URL = `https://www.staysure.com/expat`;
export const IRE_MAIN_PAGE_URL = `https://www.staysure.com/ie`;
export const SPAIN_MAIN_PAGE_URL = `https://www.staysure.com/es`;
export const UK_QUOTE_URL = `https://www.staysure.co.uk/`;
export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENV || "production";
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const HOME_URL = process.env.NEXT_PUBLIC_HOME_URI;
export const ADDRESS_API_URL = process.env.NEXT_PUBLIC_ADDRESS_API_URL;
export const LOGIN_PAGE_URL = `https://my.staysure.co.uk/signin`;
export const PAYMENT_URL = `/delivery/payments`;
export const EXPAT_PAGE_URL = `http://www.staysure.com/`;
export const QA_ENVIRONMENT = `https://quotebff.api.sae.qa.staysuregroup.com/`;

// Payment Gateway Identifiers
export const PAYMENT_GATEWAY_STRIPE = "CPS";
export const PAYMENT_GATEWAY_BARCLAYS = "SMARTPAY_BUREAU";

// Payment Error Codes
export const PAYMENT_ERROR_POLICY_ALREADY_EXISTS = 1055;
export const PAYMENT_ERROR_ALREADY_CAPTURED = 1103;

// Payment Query Parameters
export const PAYMENT_ALREADY_CAPTURED_PARAM = "paymentAlreadyCaptured";
export const PAYMENT_ALREADY_CAPTURED_VALUE = "true";

// Payment Redirect URLs
export const QUOTE_CONFIRMATION_WITH_PAYMENT_CAPTURED = `/you-are-now-covered?${PAYMENT_ALREADY_CAPTURED_PARAM}=${PAYMENT_ALREADY_CAPTURED_VALUE}`;
export const RENEWAL_CONFIRMATION_WITH_PAYMENT_CAPTURED = `/confirmation?${PAYMENT_ALREADY_CAPTURED_PARAM}=${PAYMENT_ALREADY_CAPTURED_VALUE}`;

export const ADDRESS_API_KEY = process.env.NEXT_PUBLIC_ADDRESS_API_KEY;
export const BFF_API_KEY = process.env.NEXT_PUBLIC_BFF_API_KEY;
export const OPTIMIZELY_ID = process.env.NEXT_PUBLIC_OPTIMIZELY_ID ?? "";
export const MAZE_KEY = process.env.NEXT_PUBLIC_MAZE_KEY ?? "";

export const SINGLE_TRIP = "SINGLE_TRIP";
export const ANNUAL_MULTI_TRIP = "ANNUAL_MULTI_TRIP";

export const BASIC = "BASIC";
export const COMPREHENSIVE = "COMPREHENSIVE";
export const SIGNATURE = "SIGNATURE";

export const ESSENTIALS = "ESSENTIALS";
export const CLASSIC = "CLASSIC";
export const DELUXE = "DELUXE";

export const PAY_AT_ONCE = "PAY_AT_ONCE";
export const SPREAD_THE_COST = "SPREAD_THE_COST";

export const PRODUCT = process.env.NEXT_PUBLIC_PRODUCT ?? "staysure";
export const APPLICATION = process.env.NEXT_PUBLIC_APPLICATION ?? "quote";
export const APPLICATION_TYPE = getApplicationType(APPLICATION);

export const SECONDARY_PRODUCT =
  process.env.NEXT_PUBLIC_SECONDARY_PRODUCT || undefined;

export const PRODUCT_FOOTER_DOMAIN = SECONDARY_PRODUCT || PRODUCT;

export const STS_MYACCOUNT_LOGIN_URL = `https://my.staysure.co.uk/`;
export const PRODUCT_DOMAIN =
  process.env.NEXT_PUBLIC_API_PRODUCT_DOMAIN ?? "STS"; // API domain

export const DASHBOARD_ENABLED =
  process.env.NEXT_PUBLIC_DASHBOARD_ENABLED || "false";

export const MEDICAL_FLOW_V2_ENABLED =
  process.env.NEXT_PUBLIC_MEDICAL_FLOW_V2_ENABLED || "false";

export const AVT_MYACCOUNT_LOGIN_URL = `https://my.avantitravelinsurance.co.uk/`;

export const TERMS_OF_BUSINESS = "Terms of business";
export const TERMS_OF_BUSINESS_URL =
  "https://www.staysure.co.uk/terms-of-business/";

export const ORIGIN_COUNTRY_API = "/api/originCountry/";
export const MY_ACCOUNT_URL = process.env.NEXT_PUBLIC_MY_ACCOUNT_URL;

export const INT_COUNTRY = process.env.NEXT_PUBLIC_INT_COUNTRY || null;

// Verisk Library
export const VERISK_BASE_URL = process.env.NEXT_PUBLIC_VERISK_BASE_URL || "";
export const VERISK_URL = `${VERISK_BASE_URL}/api/v1`;
export const VERISK_KEY = process.env.NEXT_PUBLIC_VERISK_BFF_API_KEY || "";
export const COMPONENT_V3_STAYSURE_BRAND = "sts";
export const COMPONENT_V3_AVANTI_BRAND = "avt";
// brand
export const STYLESHEET = "stylesheet";
export const BRAND_AVANTI = "avanti";
export const BRAND_STAYSURE = "staysure";
export const BRAND_EXPAT = "expat";

// Experiments
export const VARIANT_FLOW = "variant";
export const CONTROL_FLOW = "control";

export const AVANTI_FONT = {};
export const AMT_POLICY_START_DATE_MAX_DAYS = 90;
export const PUBLIC_HOME_URI = process.env.NEXT_PUBLIC_HOME_URI;
export const MAX_ADDRESS_LENGTH = 60;
export const MOBILE_BREAKPOINT = 600;

// Country Codes
export const UK_COUNTRY_CODE = "UK";
export const ISO_UK_COUNTRY_CODE = "GB";

// Country Names
export const UK_COUNTRY_NAME = "United Kingdom";

// Optimizely variables
export const TRAVELING_TO_VARIATION = "travelingToVariationOne";

// Help Overlay
export const HELP_BUTTON_AVATAR_PATH =
  process.env.NEXT_PUBLIC_HELP_BUTTON_AVATAR_PATH ||
  "/images/susie-profile.svg";

export const HELP_OVERLAY_NEW_ICON_PATH = "/images/help-overlay-icon.svg";

export const DESKTOP_BREAKPOINT = 904;

export const MAGNOLIA_REVALIDATION_TIME = 15 * 60; // 15 minutes in seconds

// ST AMT Toggle Modal
export const ST_AMT_SWITCH_DATE_MODAL_HEIGHT = { DESKTOP: 420, MOBILE: 370 };
export const ST_AMT_SWITCH_DATE_MODAL_SAFE_TOP_PERCENTAGE = {
  DESKTOP: 40,
  MOBILE: 12,
};

//document ids
export const GADGET_COVER = "gadget-cover";

export const TRUSTPILOT_AVN_URL =
  "https://www.trustpilot.com/review/www.avantitravelinsurance.co.uk";

export const TRUSTPILOT_STS_URL =
  "https://uk.trustpilot.com/review/www.staysure.co.uk";

export const BRANDDOMAIN_AVN = "avantitravelinsurance.co.uk";

export const BRANDDOMAIN_STS = "staysure.co.uk";

export const isSTSUK =
  PRODUCT === BRAND_STAYSURE &&
  APPLICATION === "quote" &&
  PRODUCT_DOMAIN === "STS";

export const ERROR = "error";
export const WARNING = "warning";
